import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components"

export const PlatformHeroTitleH1 = styled.h1`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 0 0 var(--spacing--M);
  gap: var(--spacing--base-0-5);

  ${MEDIA_QUERIES.M} {
    gap: 0;
  }

  .rotating-headline {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 0 0.2em; // width of space character
    justify-content: center;
    margin: 0;
    line-height: var(--line-height--tighter);

    ${MEDIA_QUERIES.S} {
      align-items: stretch;
      flex-direction: row;
    }

    ${MEDIA_QUERIES.M} {
      line-height: var(--line-height--tight);
    }

    > * {
      display: block;
      position: relative;
      z-index: 3;
    }
  }

  .nouns-wrapper {
    position: relative;
    z-index: 1;
    transition: width 0.6s ease-out;
    height: calc(var(--font-size--7XL) * var(--line-height--tighter));

    ${MEDIA_QUERIES.M} {
      height: calc(var(--font-size--7XL) * var(--line-height--tight));
    }

    &::before,
    &::after {
      background: linear-gradient(var(--color--basics-white) 80%, rgba(var(--color--basics-white-rgb), 0));
      content: "";
      display: block;
      height: 100%;
      left: 50%;
      position: absolute;
      top: -100%;
      transform: translateX(-50%);
      width: 100vw;
      z-index: 2;
    }

    &::after {
      background: linear-gradient(rgba(var(--color--basics-white-rgb), 0) 80%, var(--color--basics-white));
      bottom: -100%;
      top: auto;
    }
  }

  .noun {
    display: block;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 50%;
    opacity: 0;
    transform-origin: center center;

    .is-ready& {
      transition: transform 0.6s ease-out, opacity 0.4s ease-out 0.2s;
      transform: translate(-50%, -100%);
    }

    &.is-current {
      position: relative;
      opacity: 1;
      transform: translate(-50%, 0%);
      
      .is-ready& {
        position: absolute;
      }
    }

    &.is-next {
      transform: translate(-50%, 100%);
    }
  }

  .static-headline {
    position: relative;
    z-index: 3;
    margin: 0;
  }
`
